// @flow
import * as React from 'react'
import { ZentakeContext } from 'utils/ZentakeContext'

import OpacityBg from '../OpacityBg'

type Props = {
  isVisible: boolean,
  canDismiss: boolean,
  onClose: () => void,
  message: string,
}

function ModalTextMessagePreview({
  isVisible,
  canDismiss,
  onClose,
  message,
}: Props): React.Node {
  const { teamDetails } = React.useContext(ZentakeContext)

  if (!isVisible) return null

  return (
    <OpacityBg onClick={canDismiss ? onClose : () => {}}>
      <div className="flex-1 rounded border max-w-xs">
        <div className="p-8" style={{ backgroundColor: '#f6f6f6' }}>
          <div className="text-txt-emphasis space-y-5">
            <p className="whitespace-pre-line">
              {message}{' '}
              <span className="underline text-zentake">
                https://cloud.zentake.io
              </span>
            </p>
            <p>{teamDetails?.name}</p>
          </div>
        </div>
      </div>
    </OpacityBg>
  )
}

export default ModalTextMessagePreview
